//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
// import Breadcrumb from '@/components/Breadcrumb'
// import LangSelect from '@/components/LangSelect'
import { getLocal } from '@/utils/globalState'
export default {
  extends: vComponent,
  data () {
    return {
      leftDrawerOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'theme'
    ])
  },
  watch: {
  },
  created () {
  },
  methods: {
    getLocal,
    toggleSideBar () {
      this.$store.dispatch('ToggleSideBar')
    },
    clickBack () {
      window.history.back()
    },
    logout () {
      /*
      this.$store.dispatch('LogOut').then(() => {
        const site = getLocal('site')
        if (site !== undefined && site !== null) {
          location.hash = `${site}/login`
        } else {
          location.hash = `/login`
        }
        location.reload()
      })
      */
    }
  }
}
